import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const iconForComponentStatus = status => <div className={classnames('icon', status)} />;

export default function Component (props) {
  return (
    <div title={props.name} className={classnames('component', props.status)}>
      <span className="name">{props.name}</span>
      {iconForComponentStatus(props.status)}
    </div>
  );
}

Component.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/stride/sidebar/component.jsx